import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'
import { PlanType, SnpType, WaypointResult } from '~/generated/api-clients-generated'

export class PreApplyPageVersionNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const session = SessionStore.use()
    const { flag } = FeatureFlags.use()
    const { applications } = ApplicationStore.use()

    const preApplyPageConfig = computed(
      () => flag<Record<string, any>>('pre-apply-page-config').value
    )
    const dsnpAppGateEnabled = computed(() => flag<boolean>('dsnp-app-gate').value)

    const getCurrentApp = () => {
      return applications.find((a) => a.id == session?.currentApplicationId) ?? null
    }

    const snpType = session?.pendingApplicationData?.snpType ?? getCurrentApp()?.snpType ?? null

    // Check DSNP app gate before the general pre-apply config
    if (dsnpAppGateEnabled.value && snpType === SnpType.DualEligible) {
      return this._destinations.get(WaypointResult.PreApply_DsnpAppGate) ?? null
    }

    const planType = session?.pendingApplicationData?.planType ?? getCurrentApp()?.planType ?? null

    const planTypeKey = PlanType[planType ?? PlanType.MAPD].toUpperCase()
    const pageId = preApplyPageConfig.value?.[planTypeKey]?.page ?? null

    let result: WaypointResult | null = null

    switch (pageId) {
      case 'push-to-cs':
        result = WaypointResult.PreApply_PushToCs
        break
      case 'medicare-card':
        session.applicationMedicareCardModalShown = true
        result = WaypointResult.PreApply_MedicareCard
        break
      default:
        result = WaypointResult.Next
    }

    return this._destinations.get(result) ?? null
  }
}
